import { render, staticRenderFns } from "./AddHotkey.vue?vue&type=template&id=0c6b2549"
import script from "./AddHotkey.vue?vue&type=script&lang=js"
export * from "./AddHotkey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports